import PaymentDueSummary from "./PaymentDueSummary";
import { connect } from "react-redux";
import { getTotalExcludedTaxes } from "app/pages/Booking/bookingSelectors";
import {
	calculatePartialPaymentAmount,
	getBookingPaymentMode,
	getPayNowAmount,
} from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = state => {
	const payAtPropertyAmount = getTotalExcludedTaxes(state);

	return {
		payNowAmount: getPayNowAmount(state),
		paymentMode: getBookingPaymentMode(state),
		mensualite2Fois: calculatePartialPaymentAmount(state),
		payAtPropertyAmount,
	};
};

export default connect(mapStateToProps)(PaymentDueSummary);
